export default angular
  .module('app.regions', [])
  .name;

require('./services/regions');



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/regions/index.js